import React from "react";
import Header from "../../components/Header/Header";
import "./HomePage.css";
import LandingSection from "../../components/LandingSection/LandingSection";
import Jumbotron from "../../components/Jumbrotron/Jumbotron";
import MainParticles from "../../components/Particles/MainParticles";
import ThreeSection from "../../components/ThreeSection/ThreeSection";
import CasesSection from "../../components/CasesSection/CasesSection";
import Footer from "../../components/Footer/Footer";
import ParallaxSections from "../../components/ParallaxSection/ParallaxSections";

function HomePage() {
  return (
    <div className="home-page">
      <Header />
      <LandingSection />
      <Jumbotron />
      <ParallaxSections />
      {/* <ThreeSection/> */}
      <CasesSection />
      <Footer />
      <MainParticles />
    </div>
  );
}

export default HomePage;
